module.exports = __webpack_public_path__ + "img/icon-sti-dest-relabel.083f23c2.svg";